import config from 'src/config'

function load(component) {
  return () => import(`src/${component}.vue`)
}

const MODULE_PATH = '/bonus/management/'

export default [
  {
    path: MODULE_PATH,
    component: load('containers/Full'),
    name: 'Bonus',
    meta: {
      title: 'Common.menu.bonus_management',
      menuItem: true,
      sorting: config.sidebar.menu.sorting.modules.bonus,
      icon: 'money',
    },
    children: [
      {
        path: MODULE_PATH + 'income/statement',
        component: load('application/bonus/components/CWIncomeBonusStatement'),
        name: 'CW Bonus Income Statements',
        meta: {
          title: 'Common.menu.cw_income_statement',
          icon: 'attach_money',
          menuItem: true,
          sorting: 601,
        },
      },
      {
        path: MODULE_PATH + 'yearly/reports',
        component: load('application/bonus/components/YearlyIncomeReports'),
        name: 'Yearly Income Statements',
        meta: {
          title: 'Common.menu.yearly_income_statement',
          icon: 'attach_money',
          menuItem: true,
          sorting: 602,
        },
      },
      {
        path: MODULE_PATH + 'stockist/commission/reports',
        component: load('application/bonus/components/StockistCommissionStatement'),
        name: 'Stockist Commission Statements',
        meta: {
          title: 'Common.menu.stockist_commission_statements',
          icon: 'attach_money',
          menuItem: true,
          sorting: 603,
        },
      },
      {
        path: MODULE_PATH + 'cw/bonus/report',
        component: load('application/bonus/components/CWIncomeBonusReport'),
        name: 'CW Bonus Report',
        meta: {
          title: 'Common.menu.cw_bonus_report',
          icon: 'attach_money',
          menuItem: true,
          sorting: 604,
        },
      },
      {
        path: MODULE_PATH + 'sv/manual/update/list',
        component: load('application/bonus/components/MemberBonusAdjustmentList'),
        name: 'Member Bonus Manual Adjustment List',
        meta: {
          title: 'modules.bonus.manualAdjustment.manualAdjustmentList.title',
          icon: 'attach_money',
          menuItem: true,
          sorting: 605,
        },
      },
      {
        path: MODULE_PATH + 'sv/manual/update/new/[:memberID]',
        component: load('application/bonus/components/MemberBonusAdjustmentArea'),
        name: 'New Member Bonus Manual Adjustment',
        props: true,
        meta: {
          title: 'modules.bonus.manualAdjustment.newAdjustment.title',
          icon: 'attach_money',
          menuItem: false,
          sorting: 606,
        },
      },
      {
        path: MODULE_PATH + 'sv/manual/update/view/[:bonusID]',
        component: load('application/bonus/components/MemberBonusAdjustmentArea'),
        name: 'View Member Bonus Manual Adjustment',
        props: true,
        meta: {
          title: 'modules.bonus.manualAdjustment.viewAdjustment.title',
          icon: 'attach_money',
          menuItem: false,
          sorting: 607,
        },
      },
    ],
  },
]
